module Cfnc
{
    "use strict";

    export interface INameValue<T, A>
    {
        name: T;
        value: A;
    }

    export class NameValue implements INameValue<string,string>
    {
        name: string = "";
        value: string = "";
    }
}